import { render } from "./FormTextarea.vue?vue&type=template&id=2a2b6726"
import script from "./FormTextarea.vue?vue&type=script&lang=js"
export * from "./FormTextarea.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\skyle\\source\\repos\\skylab\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__